import { render, staticRenderFns } from "./form-add-chimney.vue?vue&type=template&id=15dbf0a6&"
import script from "./form-add-chimney.vue?vue&type=script&lang=ts&"
export * from "./form-add-chimney.vue?vue&type=script&lang=ts&"
import style0 from "./form-add-chimney.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports